import { FormControlBase } from '../models/form-control-base';
import { FormControlTypeEnum } from '../models/form-control-type.enum';

export class FormControlFormula extends FormControlBase<string> {
	public controlType = FormControlTypeEnum.Formula;
	public formulaToCalculate: string | null;
	public decimalPlaces: number | null;

	public constructor(fcf: Partial<FormControlFormula>) {
		super(fcf);
		this.formulaToCalculate = fcf.formulaToCalculate;
		this.decimalPlaces = fcf.decimalPlaces;
	}
}
